import {lazy, trigger, filter} from './lang.js';
import {doc} from './documentation.js';

doc(
    "sparse",
    {
        "sparseness": "how dense the output should be (0-1)",
    },
    "Controls density of triggers by filtering out triggers. sparseness: 0-1 "
);

const isSubSequenceEffect = (effect) => {
    return effect.track.envelopesTrack !== undefined;
};

export const sparse = (sparseness, fn) => {
    let lastMem = undefined;
    let mem = {};
    let lastStep = undefined;
    let output = 0;

    const isFirstStep = (stepNumber) => {
        let ret = stepNumber === 0 && lastStep !== stepNumber;
        lastStep = stepNumber;
        return ret;
    };

    const recordStat = (stepNumber) => {
        if (isFirstStep(stepNumber)) {
            lastMem = mem;
            mem = {};
            output=0;
        }
        if (!mem[stepNumber]) {
            mem[stepNumber]=0;
        }
        mem[stepNumber]++;
    };

    const getTotal = (mem) => {
        return Object.keys(mem).reduce(
            (a,b) => mem[b] + a, 0);
    };

    const getMaxMap = (mem, density) => {
        let _mem = {};
        for (let step in mem) {
            _mem[step] = mem[step] * density;
        }
        let carry  = 0;

        // we do addition where we make sure
        // each elemennt in the list is an integer,
        // and carry over the "remainder" (i.e. x - floor(x))
        // to the next term
        
        // (0.2) 0.8 0.1 0.7
        // 0 1 0.1 0.7
        // 0 1 0 0.8
        for (let step in _mem) {
            let value = _mem[step];
            let next = carry + value;

            _mem[step] = Math.floor(next);
            carry =  next - Math.floor(next);
        }
        return _mem;
    };

    const getStepNumber = (stepNumber, effect) => {
        if (isSubSequenceEffect(effect)) {
            let subSequence = effect.track;
            let maxLength = Math.max(
                ... subSequence.tracks.map(
                    ({pattern}) => pattern.length()));
            return subSequence.sequencerEngine.trackStep %
                maxLength;
        } else {
            return stepNumber;
        }
    };

    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        let _sparseness = lazy(sparseness, ...args);

        stepNumber = getStepNumber(stepNumber, effect);

        if (!stepData) {
            return filter(false);
        }

        recordStat(stepNumber, effect);

        if (_sparseness === 1 || stepData.slide) {
            // no point doing any calculations since
            // we will always pass these thru (when sparseness=1)
            return filter(true);
        }

        let maxMap = getMaxMap(lastMem || mem, _sparseness);

        if (mem[stepNumber] > maxMap[stepNumber]) {
            return filter(false);
        }
        output++;
        return filter(true);
    };
};
